module.exports = __webpack_public_path__ + "img/bg.4780fcd2.png";